import React from "react";

const MessageBubble = ({ message, type }) => (
  <div className="flex gap-4">
    {type === "received" && (
      <div className="w-8 h-8 rounded-full overflow-hidden bg-blue-100 flex items-center justify-center text-blue-600">
        <img src="/imgs/logo-icon.jpg" alt="UR" />
      </div>
    )}
    <div
      className={`flex-1 p-2 text-sm rounded-xl ${
        type === "received"
          ? "bg-white text-black border border-gray-300 mr-4"
          : "bg-primary text-white ml-4"
      }`}>
      <span>{message.content}</span>
    </div>
    {type === "send" && (
      <div className="w-8 h-8 rounded-full overflow-hidden bg-blue-100 flex items-center justify-center text-blue-600">
        <img src="/imgs/user-avatar.jpg" alt="UR" />
      </div>
    )}
  </div>
);

export default MessageBubble;
